import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router' ;

import { ApiService, DialogsService } from '../../custom-material/Services/';
import { BuildingModel, BuildingTypeModel, DiagnosticModel, UserModel } from '../../main/Models/';
import { BuildingChooseComponent } from '../../main/Components/building-choose/building-choose.component';
import { globalData } from 'src/app/main/Models/global.model';
import { toollist } from './buildings.tools';
import { BaseComponent } from 'src/app/main/Components/base/base.component';


@Component({
  selector: 'list-buildings',
  templateUrl: './t_buildings.component.html',
  styleUrls: ['./buildings.component.less']
})
export class BuildingsComponent extends BaseComponent implements OnInit {

  buildingTypes: Array<BuildingTypeModel> = [];

  /***get autoSelect()
  {
    if(this.route.snapshot.params['building']!=undefined) {
      return +this.route.snapshot.params['building'];
    } else {
      return 'mine';
    }
  }*/

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public gd: globalData
    ) {
      super(gd);
      this.gd.showChooser = true;
      this.gd.headerTitle = "Etablissements et audits";
      this.gd.headerIcon = "location_city";
      this.gd.toolService =null,
      this.gd.toollist = toollist;
      this.gd.headerBuilding = null;
    }

  ngOnInit() {}
}
